export enum GuideLineEnum {
  Rubric = 'rubric',
  RegisterField = 'register-field',
  CreateSubSection = 'create-sub-section',
  AdminOnboardingTour = 'admin-onboarding-tour',
}
